<template>
  <div class="b2b-navigation-bar">
    <div class="header-sidebar">
      <div @click="goToHome" class="b2b-logo">
        <img
          :src="
            'https://detailss3web.s3.amazonaws.com/images/logo/' +
            clientName +
            'logo'
          "
          alt=""
          srcset=""
        />
      </div>
      <div class="b2b-navbar-options">
        <div
          @click="closeMainNav"
          class="b2b-close-button"
          v-if="appDrawer && !isMobileScreen"
        >
          <span>
            <img src="static/icons/menu-white.svg" />
          </span>
        </div>
      </div>
    </div>
    <v-list class="b2b-nav-list">
      <v-list-group
        v-for="item in appNavItems"
        :value="isModuleActive($route, item)"
        :key="item.title"
        v-show="item.hasPermission"
        no-action
      >
        <v-list-tile class="main-menu" slot="activator">
          <v-list-tile-content>
            <v-list-tile-title
              @click="selectedNavItem(item)"
              class="main-menu--title"
            >
              <div class="main-menu--icon">
                <img
                  :class="{
                    'svg-color': isModuleActive($route, item),
                  }"
                  :src="item.img"
                  alt="calendar"
                />
              </div>
              <div
                :class="{
                  'active-item': isModuleActive($route, item),
                }"
                class="main-menu--text"
              >
                <template>
                  {{ $t(item.title) }}
                </template>
              </div>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          class="sub-menu--title"
          v-for="subItem in item.children"
          :key="subItem.title"
        >
          <span
            :class="{
              active: isSubmenuActive($route, item, subItem),
            }"
          >
            <a
              :class="{
                active: isSubmenuActive($route, item, subItem),
              }"
              class="subItem"
              @click.stop="selectedSubNavItem(subItem)"
            >
              <router-link
                tag="li"
                :to="'/' + base + '/' + item.route + '/' + subItem.route"
              >
                {{ subItem.title }}
              </router-link>
            </a>
          </span>
        </v-list-tile>
      </v-list-group>
    </v-list>
    <div class="b2b-footer-logo">
      <!-- powered by &nbsp; -->
      <a target="_blank" href="https://www.detailsdetails.eu/">
        <img :src="'./static/icons/b2b/share-logo.png'" alt="" srcset=""
      /></a>
    </div>
  </div>
</template>

<script>
import { clientName } from "../../modules/b2b/services/http-client.js";
import * as types from "../../modules/b2b/store/types.js";
import { B2BStoreNamespace as storeNS } from "../../modules/b2b/store/index";
import { mapGetters, mapActions, mapState } from "vuex";
import { FixedProperties } from "../../modules/b2b/models/Fixed-Properties";
import { isMobile } from "../../utility";
export default {
  props: {
    base: {
      type: String,
      default: "b2b",
    },
    items: {
      type: Array,
    },
    showtemporary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      group: null,
      isMobileScreen: false,
      clientName:clientName
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        let activeRouteItem = this.appNavItems.find(
          (r) => r.title == this.$route.name && r.hasPermission
        );
        if (activeRouteItem) {
          this.$store.commit(
            `${storeNS}/${types.B2B_ACTIVE_ROUTE_ITEM}`,
            activeRouteItem
          );
          const param = this.$router.currentRoute.params["royaltyDate"];
          if (param) {
            const item = {
              title: FixedProperties.ROYALTY_ACCOUNT_TITLE,
              route: param,
              parent: FixedProperties.ROYALTY_ACCOUNT_ROUTE,
              img: "static/icons/b2b/label-inactive.svg",
              children: [],
            };
            this.$store.commit(
              `${storeNS}/${types.B2B_ACTIVE_SUB_ROUTE_ITEM}`,
              item
            );
          }
        } else {
          this.$store.commit(`${storeNS}/${types.B2B_ACTIVE_ROUTE_ITEM}`, {
            title: "",
            route: "",
            img: "",
            children: [],
          });
          this.$store.commit(
            `${storeNS}/${types.B2B_ACTIVE_SUB_ROUTE_ITEM}`,
            null
          );
        }
      },
    },
  },
  mounted() {
    if (isMobile()) {
      this.isMobileScreen = true;
    } else {
      this.isMobileScreen = false;
    }
  },
  created() {
    this[types.B2B_FETCH_ROYALTY_YEARS]();
  },

  methods: {
    ...mapActions(storeNS, {
      [types.B2B_FETCH_ROYALTIES_BY_YEAR]: types.B2B_FETCH_ROYALTIES_BY_YEAR,
      [types.B2B_FETCH_ROYALTY_YEARS]: types.B2B_FETCH_ROYALTY_YEARS,
    }),
    closeMainNav: function () {
      this.$emit("closeMainNav", false);
    },
    goToHome: function () {
      this.$router.push({
        name: FixedProperties.HOME_TITLE,
      });
    },
    selectedNavItem: function (item) {
      this.$store.commit(`${storeNS}/${types.B2B_ACTIVE_ROUTE_ITEM}`, item);
      if (item.route === "user_profile") {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "edit_user",
          },
        });
      } else if (item.route === "b2bLogin") {
        this.$router.push({
          name: item.route,
        });
      }
    },
    selectedSubNavItem: function (item) {
      if (this.appNavItems && this.appNavItems.length > 0) {
        const mainItem = this.appNavItems.find((a) => a.route === item.parent);
        if (mainItem) {
          this.$store.commit(
            `${storeNS}/${types.B2B_ACTIVE_ROUTE_ITEM}`,
            mainItem
          );
        }
      }
      this.$store.commit(
        `${storeNS}/${types.B2B_SET_IS_LOADED_ROYALTY_PAGE_DATA}`,
        false
      );
      this.$store.commit(`${storeNS}/${types.B2B_ACTIVE_SUB_ROUTE_ITEM}`, item);
      if (item && item.parent == FixedProperties.ROYALTY_ACCOUNT_ROUTE) {
        this[types.B2B_FETCH_ROYALTIES_BY_YEAR]();
      }
    },

    isModuleActive: function (route, item) {
      const routePattern = new RegExp(
        `/${this.base}/${item.route.toLowerCase()}`,
        "ig"
      );
      const isMatch = item.expandable ? true : routePattern.exec(route.path);
      return isMatch;
    },

    isSubmenuActive: function (route, item, submenu) {
      const routePattern = new RegExp(
        `/${this.base}/${item.route.toLowerCase()}/${
          typeof submenu.route == "string"
            ? submenu.route.toLowerCase()
            : submenu.route
        }`,
        "ig"
      );
      const isMatch = routePattern.exec(route.path);
      return isMatch;
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      activeRouteItem: "activeRouteItem",
      activeSubRouteItem: "activeSubRouteItem",
      showCloseIcon: "showCloseIcon",
      appNavItems: "appNavItems",
      appDrawer: "appDrawer",
    }),
    clientId() {
      return clientId;
    },
  },
};
</script>

<style lang="scss">
.b2b-navigation-bar {
  .b2b-nav-list {
  margin-top: 50px;
}

.b2b-nav-list .list__group {
  margin: 0 10px;
}
.b2b-nav-list .list__group div.list__group__items {
  .sub-menu--title {
    .list__tile {
      display: flex;
      span {
        border-left: 1px solid #c8c8c8;
        padding-left: 5px;
        height: 100%;
        &.active {
          border-left: 2px solid #50e890;
          height: 100%;
        }
      }

      .li {
        flex: 4;
        width: 100%;

        .a {
          flex: 4;
          width: 100%;
        }
      }
    }
  }
}
.b2b-nav-list .list__group .list__group__items .sub-menu--title a {
  flex: 4;
  width: 100%;
  flex: 4;
  color: #c8c8c8;
  font-family: Roboto;
  font-size: 13px;
  line-height: 18px;

  &.active {
    color: #50e890;
  }
  li {
    text-align: center;
    padding-top: 4px;
  }
}
.b2b-nav-list .list__group__header {
  background: #424242;
}
.b2b-nav-list .list__group {
  margin: 0 0px;
  background-color: #686868;
}
.b2b-nav-list .list__group::after {
  width: 0%;
}

.b2b-nav-list .main-menu {
  padding-left: 22px;

  .list__tile {
    max-height: 29px;
  }

  .main-menu--title {
    display: flex;
    .main-menu--icon {
      padding-right: 8px;
      color: rgb(241, 224, 224);
    }

    .main-menu--text {
      flex: 4;
      color: #c8c8c8;
      font-family: Roboto;
      font-size: 13px;
      line-height: 18px;
      &.active-item {
        color: #50e890 ;
      }
    }
  }
}

img.svg-color {
  filter: invert(0.19) sepia(0.5) saturate(3.5) hue-rotate(90deg)
    brightness(1.09);
}
.header-sidebar {
  display: grid;
  grid-template-columns: 2fr 0.5fr;
  grid-gap: 1rem;
  padding: 30px 0.5rem 0 0.5rem;
  align-items: center;

  .b2b-logo {
    display: flex;
    justify-content: flex-start;
    margin-left: 5px;
    overflow: hidden;
    img {
      width: 100%;
      cursor: pointer;
      height: 100%;
      max-height: 120px;
      object-fit: cover;
    }
  }
  .b2b-navbar-options {
    padding-top: 8px;
    .b2b-close-button {
      display: flex;
      color: white;
      border: none;
      border-radius: 0;
      cursor: pointer;
    }
  }
}

.b2b-footer-logo {
  display: flex;
  position: absolute;
  padding-left: 25px;
  bottom: 20px;
  img {
    display: flex;
    width: 100px;
    max-width: 100px;
    height: 45px;
    cursor: pointer;
  }
}
}
</style>
